import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast } from 'services/toasterService';

export default function useAddNewEmpolyeeFolder() {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.REPOSITORY_ADD_AND_DELETE_EMPLOYESS_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        // SuccessToast({ text: data?.message });
        // cb();
        queryClient.invalidateQueries('repository-folders');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
